import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { BetWrightCompliancePopupLogo } from 'src/assets/logos/compliancePopup/BetWrightCompliancePopupLogo';
import { BetWrightLogo } from 'src/assets/logos/BetWrightLogo';
import { BetWrightBrandIcon } from 'src/assets/brandIcons/BWBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const BetWrightMainLogoWrapper = withConfig(theme => styled('div', { label: 'BetWrightMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const BetWrightMainLogo = styled(BetWrightLogo, { label: 'BetWrightMainLogo' })`
    width: 148px;
    height: 20px;
    margin: 0 auto;
`;

export const BetwrightBrandIconWrapper = styled(BetWrightBrandIcon, { label: 'BetwrightBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(BetWrightCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
